import { useState } from "react";
import CommonForm from "../../../../components/form/form";
import DefaultButton from "../../../../components/buttons/defaultButton";
import DefaultInput from "../../../../components/inputs/defaultInput";

const PoliciesRulesSection = ({ fields, onSubmit, blackoutDates, setBlackoutDates, initialData }) => {
  const [selectedDate, setSelectedDate] = useState("");

  const handleAddBlackoutDate = () => {
    if (selectedDate) {
      setBlackoutDates([...blackoutDates, selectedDate]);
      setSelectedDate("");
    }
  };

  const handleRemoveBlackoutDate = (index) => {
    setBlackoutDates(blackoutDates.filter((_, i) => i !== index));
  };

  const handleSaveBlackoutDates = async () => {
    if (onSubmit && blackoutDates.length > 0) {
      await onSubmit({ blackout_dates: blackoutDates });
    }
  };

  const handleFormSubmit = async (values, formikHelpers) => {
    // Include blackout dates in payload if they exist
    const payload = { ...values };
    if (blackoutDates && blackoutDates.length > 0) {
      payload.blackout_dates = blackoutDates;
    }
    if (onSubmit) {
      await onSubmit(payload, formikHelpers);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-4">
      {/* Section Description */}
      <div className="bg-information-50 border border-information-200 rounded-lg p-4">
        <h4 className="text-theme font-semibold mb-2 flex items-center gap-2">
          <span>📋</span> About Policies & Rules
        </h4>
        <p className="text-sm text-theme mb-2">
          Configure organization-wide leave policies that apply to all employees. These rules control when and how employees can apply for leave.
        </p>
        <div className="bg-white rounded p-3 mt-2">
          <p className="text-xs font-medium text-theme mb-1">Example Scenario:</p>
          <p className="text-xs text-textLight">
            If you set "Backdate Window" to 7 days and "Max Consecutive Days" to 15: An employee can apply for leave up to 7 days in the past, but cannot apply for more than 15 consecutive days. If they try to apply for 20 days, the system will reject it.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-lg ">
        <h3 className="text-lg font-semibold text-theme mb-2">Leave Policies & Rules</h3>
        <p className="text-sm text-textLight mb-4">
          Set global rules that apply to all leave types and employees. These policies help maintain consistency and prevent leave abuse.
        </p>
        <CommonForm
          fields={fields}
          onSubmit={handleFormSubmit}
          initialData={initialData || {}}
          submitButtonText="Save Policies"
          showCancelButton={false}
          gap="gap-4"
          
          fieldClassName="bg-light p-3 rounded"
        />
      </div>

      <div className="bg-white rounded-lg">
        <h3 className="text-lg font-semibold text-theme mb-2">Blackout Dates</h3>
        <p className="text-sm text-textLight mb-4">
          Mark specific dates when leave applications are not allowed. Useful for peak business periods, mandatory training days, or critical project deadlines.
        </p>
        <div className="bg-warning-50 border border-warning-200 rounded p-3 mb-4">
          <p className="text-xs font-medium text-theme mb-1">💡 Impact:</p>
          <p className="text-xs text-textLight">
            When a date is marked as blackout, employees cannot apply for leave on that date. Example: If you mark "2024-12-25" as blackout (Christmas), all leave applications for that date will be automatically rejected.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex gap-2">
            {/* <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="flex-1 px-4 py-2 border border-borderColor rounded-md bg-light text-theme focus:outline-none focus:ring-2 focus:ring-theme"
            /> */}
            <DefaultInput
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              // className="flex-1 px-4 py-2 border border-borderColor rounded-md bg-light text-theme focus:outline-none focus:ring-2 focus:ring-theme"
            />
            <DefaultButton 
              onClick={handleAddBlackoutDate}
              disabled={!selectedDate}
              name="Add Date"
              minWidth
            >
              
            </DefaultButton>
          </div>
          {blackoutDates.length > 0 && (
            <div className="flex flex-col gap-2">
              <p className="text-sm font-medium text-theme">Blackout Dates:</p>
              <div className="flex flex-wrap gap-2">
                {blackoutDates.map((date, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 bg-light px-3 py-1 rounded-md"
                  >
                    <span className="text-sm text-theme">{date}</span>
                    <button
                      onClick={() => handleRemoveBlackoutDate(index)}
                      className="text-reject hover:text-red-700 text-sm"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="flex mt-4">
            <DefaultButton 
              onClick={handleSaveBlackoutDates}
              disabled={blackoutDates.length === 0}
              name={" Save Blackout Dates"}
            >
           
            </DefaultButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliciesRulesSection;

